import { useEffect } from 'react';
import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { HeroSection } from '../../components/landing/HeroSection';
import { MostOrderedGrid } from '../../components/landing/MostOrderedGrid';
import { FeaturedProductsSlider } from '../../components/landing/FeaturedProductsSlider';
import { FeaturedRecipesSlider } from '../../components/landing/FeaturedRecipesSlider';
import { PacksSlider } from '../../components/landing/PacksSlider';
import { SolutionsSlider } from '../../components/landing/SolutionsSlider';
import { CategoriesSection } from '../../components/landing/CategoriesSection';
import { DeliveryZoneSection } from '../../components/delivery/DeliveryZoneSection';
import { GiftBanner } from '../../components/landing/GiftBanner';
import LandingPrompts from '../../components/pwa/LandingPrompts';
import type { LandingPageData } from '../../types/landing';

type LandingProps = LandingPageData & { appUrl?: string };

export default function Landing(props: LandingProps) {
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const el = document.querySelector(hash);
            el?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    const { mostOrderedProducts, featuredProducts, packs, solutions, featuredRecipes, categories, user, userAddresses, deliverySchedule, nextDeliveryLabel, suggestedCart, hasOrders } = props;

    return (
        <MainLayout>
            <Head>
                <title>Abasto Virtual</title>
                <meta
                    name="description"
                    content="Proveedor de frutas y verduras frescas para consumidores y gastronómicos en Córdoba. Venta mayorista y minorista con delivery. Entrega en 24hs."
                />
                <link rel="canonical" href={props.appUrl ?? ''} />
            </Head>
            <LandingPrompts hasOrders={hasOrders} suggestedCart={suggestedCart} />
            <div className="landing-page">
                <HeroSection showValueProps={false} nextDeliveryLabel={nextDeliveryLabel} />

                {mostOrderedProducts?.length > 0 && (
                    <MostOrderedGrid products={mostOrderedProducts} />
                )}

                {featuredRecipes?.length > 0 && (
                    <FeaturedRecipesSlider recipes={featuredRecipes} />
                )}

                {featuredProducts.length > 0 && (
                    <FeaturedProductsSlider products={featuredProducts} />
                )}

                {packs.length > 0 && (
                    <PacksSlider packs={packs} />
                )}

                <GiftBanner />

                {solutions.length > 0 && (
                    <SolutionsSlider solutions={solutions} />
                )}

                {categories.length > 0 && (
                    <CategoriesSection categories={categories} />
                )}

                <DeliveryZoneSection
                    user={user}
                    userAddresses={userAddresses || []}
                    deliverySchedule={deliverySchedule || []}
                />

                <HeroSection showOnlyValueProps />
            </div>
        </MainLayout>
    );
}
